import * as _distanceConverter from './distanceConverter'
import * as _heroImageResolver from './heroImageResolver'
import * as _CalculatePace from './CalculatePace'

export { Nobles } from './nobles'
export const distanceConverter = _distanceConverter
export const heroImageResolver = _heroImageResolver
export const calculatePace = _CalculatePace